<h2 class="property-header">Propriétés de l'évènement</h2>
<form [formGroup]="dataForm" class="without-default-focus">
    <div class="form-item form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>Id</mat-label>
            <input matInput type="text" formControlName="id" autocomplete="off" tabindex="1" readonly="true" />
        </mat-form-field>
    </div>

    <div class="form-item form-item-help">
        <mat-checkbox class="with-info-icon accent-button" formControlName="isEnabled" tabindex="2">Actif.</mat-checkbox>
        <fa-icon
            [icon]="faCircleInfo"
            class="info-icon"
            matTooltip="Si cette option est décochée, l’évènement sera désactivé et ne sera pas éxécuté par le workflow."
            matTooltipPosition="left"></fa-icon>
    </div>

    <div class="form-item form-item-help">
        <mat-form-field class="with-info-icon table-control">
            <mat-label>Conditions</mat-label>
            <app-workflow-conditions-form formControlName="conditions" required tabindex="3" [workflow]="workflow" />
        </mat-form-field>
        <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO conditions" matTooltipPosition="left"></fa-icon>
    </div>
</form>
